// shared
import req from 'shared/req';
import {errorMessage} from 'shared/actions/notifications';

export const RECEIVE_COUNTRIES = 'RECEIVE_COUNTRIES';
export const RECEIVE_CITIES = 'RECEIVE_CITIES';
export const RECEIVE_SCHOOLS = 'RECEIVE_SCHOOLS';

export const getCountries = () => {
  return (dispatch) => {
    return req({
      url: '/v1/countries',
      method: 'get'
    }).then((countries) => {
      dispatch({
        type: RECEIVE_COUNTRIES,
        countries
      });
    }).catch(() => {
      dispatch(errorMessage());
    });
  };
};

export const getCities = (country) => {
  return (dispatch) => {
    return req({
      url: '/v1/cities',
      method: 'get',
      data: {country}
    }).then((cities) => {
      dispatch({
        type: RECEIVE_CITIES,
        cities
      });
    }).catch(() => {
      dispatch(errorMessage());
    });
  };
};

export const getSchools = (country, city) => {
  return (dispatch) => {
    return req({
      url: '/v1/schools-by-country-and-city',
      method: 'get',
      data: {
        country,
        city
      }
    }).then((schools) => {
      const formattedSchools = schools.map((school) => ({
        id: school.id,
        name: school.fields.school_name
      }));

      dispatch({
        type: RECEIVE_SCHOOLS,
        schools: formattedSchools
      });
    }).catch(() => {
      dispatch(errorMessage());
    });
  };
};
